import * as _ from 'lodash';

export default {
  // БЦ
  'bs_center': (function () {
    if (!window._existingSearchTags) {
      return null;
    }

    const BCnames = window._existingSearchTags
      .filter(tag => tag.type === 'bs_center')
      .reduce((res, tag) => {
        res[tag.id] = tag.text;
        return res;
      }, {});

    // Из шапки
    const headerBC = window._landingHeader.BC;
    if (headerBC) {
      BCnames[headerBC.id] = headerBC.name;
    }

    return BCnames;
  })(),

  // Возможные назначения
  'specialty_types': (function () {
    // Тэги, которые есть при загрузке страницы
    return _.transform(window._specialties, (acc, item) => {
      acc[item.id] = item.rusName;
    }, {});
  })(),
}



// WEBPACK FOOTER //
// ./src/serp/services/tag-title/initial-tag-titles.js